import styled from "@emotion/styled";
import UserInfoCard from "@components/card/UserInfoCard";
import { InfoPanel } from "./_component";

const MyPage = () => {
  return (
    <Container>
      <UserInfoWrapper>
        <UserInfoCard />
        <InfoPanel />
      </UserInfoWrapper>
    </Container>
  );
};

export default MyPage;

const Container = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "1.2rem",
  backgroundColor: theme.color.border_gray,
}));

const UserInfoWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "1.2rem",
});
